export default __webpack_public_path__ + "static/media/cryptomoon.b549331f.png";